import React from 'react';

import classnames from 'classnames';
import {statuses, getStatus} from "../models";


const WorkflowStatus = ({ status }) => {
  const statusModel = getStatus(status) || statuses[0];
  const classes = { "workflow-status-circle": true, [`bg-${statusModel.colorName}`]: true };

  return (
    <div className="workflow-status">
      <span className={classnames(classes)} />&nbsp;&nbsp;
      {statusModel.name}
    </div>
  );
};
export default WorkflowStatus;
